/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { cn } from "@farmlands/shadcn-ui";
import React, { Children, PropsWithChildren } from "react";

import NoSalesAgreement from "@/features/sales-agreements/NoSalesAgreement";

export const DEFAULT_EMPTY_AGREEMENTS_LIST_MESSAGE = "You do not have any active Sales Agreements.";

interface AgreementListProps extends PropsWithChildren {
  className?: string;
  emptyListMessage: string;
}

export const AgreementList = (props: AgreementListProps) => {
  const childArray = Children.toArray(props.children);

  return (
    <div className={cn("flex flex-col gap-2", props.className)}>
      {(childArray.length && childArray) || (
        <NoSalesAgreement body={props.emptyListMessage || DEFAULT_EMPTY_AGREEMENTS_LIST_MESSAGE} />
      )}
    </div>
  );
};
